import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

function initBlogSwiper() {
	return new Swiper('.js-blog-slider', {
		modules: [Navigation],
		navigation: {
			nextEl: '.js-btn-next',
			prevEl: '.js-btn-back',
		},
		breakpoints: {
			992: {
				slidesPerView: 3,
				spaceBetween: 60,
			},
			575: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			0: {
				slidesPerView: 1,
				spaceBetween: 12,
			},
		},
	});
}

export default initBlogSwiper;
